var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{attrs:{"width":"5","height":"6","viewBox":"0 0 5 6","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M5 3L0.5 5.59808L0.5 0.401924L5 3Z","fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }